import { render, staticRenderFns } from "./Infobar.vue?vue&type=template&id=1c2c0748&scoped=true&"
import script from "./Infobar.vue?vue&type=script&lang=js&"
export * from "./Infobar.vue?vue&type=script&lang=js&"
import style0 from "./Infobar.vue?vue&type=style&index=0&id=1c2c0748&lang=stylus&scoped=true&"
import style1 from "./Infobar.vue?vue&type=style&index=1&id=1c2c0748&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2c0748",
  null
  
)

export default component.exports